export const basePath = `/bumble-honey-ambassadors/`;
